// extracted by mini-css-extract-plugin
export default {"from-btn-wrapper":"FormBtn_from-btn-wrapper__Wyqrt","form-nav-button":"FormBtn_form-nav-button__YyLju"};